export default {"theme":{"themes":{"light":{"primary":"#002E5D","secondary":"#666666","accent":"#0062B8","error":"#D32F2F","info":"#1FB3D1","success":"#10A170","warning":"#FFB700"}}}}
